import fromUnixTime from 'date-fns/fromUnixTime';

export const getHeaderExpiry = (response) => {
  const expiry = Number(response?.headers?.expiry);
  return Number.isFinite(expiry) ? fromUnixTime(expiry) : null;
};

export const getAuthCookieOptions = (response, now = new Date()) => {
  const expiryDate = getHeaderExpiry(response);
  return expiryDate && expiryDate > now ? { expires: expiryDate } : {};
};
